import React, { Component } from 'react';
import { RedText, BigBold } from './LayoutComponents';

export class About extends Component {

  render() {
    return (
      <div>
        <h2>금식 기도 취지</h2>
        <br/>

        지금 우리는 영적으로나 육적으로나 매우 혼란의 시기를 겪고 있음에 틀림이 없다. <br />
        온세계는 지금 이제 하나님이 말씀하신 대로 마지막을 향하여 달려가고 있음이 여기저기서 보이고 있다. <br />
        <br />
        사람은 한번 태어나서 한번 죽는 것이 정한 이치이다. 그러나 그 이후에는 이 지상에서의 삶에 대한 심판이 있을 것이다. <br />
        <br />
        <RedText>
          <b>[계 22:12]</b> <br />
          보라 내가 속히 오리니 내가 줄 상이 내게 있어 각 사람에게 그의 일한 대로 갚아 주리라 <br />
        </RedText>
        <br />
        우리가 여기서 얼마나 오래 살 것인가 아니면 짧게 살 것인가 하는 것은 중요하지 않다. <br />
        그러나 더 중요한 것은 그렇게 사는 날동안 우리가 하나님앞에 얼마나 하나님이 원하시는대로 바르게 살아드리는 가 하는 것이 더 중요한 것이다. <br />
        <br />
        <RedText>
          <b>[전 12:13]</b> <br />
          일의 결국을 다 들었으니 하나님을 경외하고 그 명령을 지킬지어다 이것이 사람의 본분이니라 <br />
        </RedText>
        <br />
        지금 하나님은 우리 한국이라는 나라를 참다 참으시다가 그분의 징계의 심판대위에 올려 놓으셨다. <br />
        <br />
        물론 우리의 생각보다 하나님의 생각은 하늘이 땅보다 높음같이 훨씬 높으시다. <br />
        <br />
        <RedText>
          <b>[사 55:8-사 55:9]</b> <br />
          (8)여호와의 말씀에 내 생각은 너희 생각과 다르며 내 길은 너희 길과 달라서 <br />
          (9)하늘이 땅보다 높음 같이 내 길은 너희 길보다 높으며 내 생각은 너희 생각보다 높으니라 <br />
        </RedText>
        <br />
        하나님은 우리나라에 대하여 잠시동안의 징계로 인하여 나중의 큰 의의 평강한 열매를 맺으시는 분이신 것이다. <br />
        우리가 믿는 하나님은 구약에서부터 보면 징계의 하나님이셨다. 그리고 그것으로 인하여 모든 것을 바로 잡으시는 분이신 것이다. <br />
        <br />
        하나님의 뜻은 반드시 이루어진다. 그리고 세상은 하나님의 뜻대로 돌아가게 되어 있다. <br />
        그리고 우리 인간은 그분의 뜻앞에 할 수 있는 것이 아무 것도 없다. <br />
        다만 오직 회개와 기도뿐인 것이다. <br />
        <br />
        하나님의 징계의 손길이 지금 우리 한국에 임하여 있는 이 때에 <br />
        우리 크리스천들은 하나님앞에 겸손히 금식하며 기도하기를 원한다. <br />
        나라를 위하여 다니엘이 예루살렘을 향하여 창문을 열어놓고 회개하고 기도한 것처럼 말이다............. <br />
        <br />
        지금은 우리가 나라를 위하여 합심하여 기도할 때이다. <br />
        그리하여 이곳에서 나라를 위하여 하루를 혹은 한끼를 금식할 기도의 용사들을 모집하고자 한다. <br />
        <br />
        이 금식기도운동은 하늘에서 하나님이 분명히 기뻐 받으시는 기도들이 될 것을 확신합니다. <br />
        <br />
        <BigBold>참여요령:</BigBold> <br />
        ● 우선 매주 나라를 위하여 하루 금식 혹은 한끼 금식을 할 것인지 하나님앞에서 결정한다. <br />
        ● 그런 후에 하루금식을 원하는 자는 하루금식하는 곳으로 클릭하여 들어가 자신의 이름과 직분을 적고 그 시로부터 해당하는 매주 요일에 하나님앞에 금식하며 나라를 위하여 기도한다. <br />
        ● 한끼 금식을 원하는 자도 마찬가지이다. <br />
        ● 나라를 위하여 기도할 때에 여기에 자세한 구국 기도문을 제시하고 있으므로 그것에 따라서 읽으면서 기도한다. <br />
        <br />
        <br />
        <RedText>
          <b>[왕상 8:38-왕상 8:39]</b> <br />
          (38)한 사람이나 혹 주의 온 백성 이스라엘이 다 각각 자기의 마음에 재앙을 깨닫고 이 전을 향하여 손을 펴고 무슨 기도나 무슨 간구를 하거든 <br />
          (39)주는 계신 곳 하늘에서 들으시고 사유하시며 각 사람의 마음을 아시오니 그 모든 행위대로 행하사 갚으시옵소서 주만 홀로 인생의 마음을 다 아심이니이다 <br />
        </RedText>
        <br />
        <RedText>
          <b>[대하 6:39]</b> <br />
          (39)주는 계신 곳 하늘에서 저희의 기도와 간구를 들으시고 저희의 일을 돌아 보옵시며 주께 득죄한 주의 백성을 용서하옵소서 <br />
        </RedText>
        <br />
        <RedText>
          <b>[대하 7:14]</b> <br />
          (14)내 이름으로 일컫는 내 백성이 그 악한 길에서 떠나 스스로 겸비하고 기도하여 내 얼굴을 구하면 내가 하늘에서 듣고 그 죄를 사하고 그 땅을 고칠지라 <br />
        </RedText>
        <br />
        <br />
        아멘! <br />
        <br />
        <BigBold>함께 나라를 위하여 금식하며 기도합시다!!<br /></BigBold>
        <br />
        구국금식기도운동 주최측 참여 목사님들: (가나다순)<br />
        <br />
      </div>
    );
  }
}
